import fr from './fr.json';

type Messages = typeof fr;
type DotPath<T, P extends string = ''> = {
  [K in keyof T & string]: T[K] extends string
    ? `${P}${K}`
    : T[K] extends object
      ? DotPath<T[K], `${P}${K}.`>
      : never;
}[keyof T & string];

export type TranslationKey = DotPath<Messages>;

const messages: Messages = fr;

export function t(key: TranslationKey): string {
  const parts = key.split('.');
  let cursor: unknown = messages;
  for (const part of parts) {
    if (cursor && typeof cursor === 'object' && part in cursor) {
      cursor = (cursor as Record<string, unknown>)[part];
    } else {
      return key;
    }
  }
  return typeof cursor === 'string' ? cursor : key;
}
